module.exports = __webpack_public_path__ + "media/images/social_icons/googleplus_square-d70253a5f192cbf01fd919d8078986a0.png";